var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFpsWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.357,
    height: 25.365,
    viewBox: "0 0 28.357 25.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36410",
    "data-name": "Group 36410",
    transform: "translate(0.75 0.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39798",
    "data-name": "Path 39798",
    d: "M18,8a4.476,4.476,0,1,1,0,8.952",
    transform: "translate(4.381 -2.067)",
    fill: "none",
    stroke: "#048bf1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39799",
    "data-name": "Path 39799",
    d: "M11.476,8V24.413A1.492,1.492,0,0,1,9.984,25.9H8.492A1.492,1.492,0,0,1,7,24.413v-7.46",
    transform: "translate(-1.032 -2.067)",
    fill: "none",
    stroke: "#048bf1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39800",
    "data-name": "Path 39800",
    d: "M16.429,9.96l6.75-5.625a1.343,1.343,0,0,1,2.2,1.033V23.5a1.343,1.343,0,0,1-2.2,1.033l-6.75-5.625H4.492A1.492,1.492,0,0,1,3,17.42V11.452A1.492,1.492,0,0,1,4.492,9.96H16.429",
    transform: "translate(-3 -4.024)",
    fill: "none",
    stroke: "#048bf1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpsWarning);
export default __webpack_public_path__ + "static/media/fps-warning.a09aa5f8b47b13025900f9641b5e1bf1.svg";
export { ForwardRef as ReactComponent };